export const getDateWithoutTime = (date: string): Date => {
  if (date) {
    const dateParts = date.split('-');
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const day = parseInt(dateParts[2], 10);

    return new Date(year, month, day, 0, 0, 0);
  }

  return new Date(date);
};

export const getDateWithoutTimeFromYYYYMMDD = (date: string): Date => {
  const formattedDate = `${date.slice(0, 4)}/${date.slice(4, 6)}/${date.slice(6, 8)}`;
  return new Date(formattedDate);
};
